<template>
    <div class="col margin-bottom-50 complaint">
        <div class="form">
            <div class="row">
                <div class="form_content clearfix w-100">
                    <span class="required-fields more-top">(*) {{ $t('default.Requiredfields')}}</span>
                    <div class="title"><h3>{{ $t('default.ComplaintWhichProduct')}}</h3></div>

                    <section class="col-sm-12 q">
                        <form-input v-model="contact.name_product" :error="errors.name_product" name="name_product" :label="$t('default.Nameproduct')" :required="true"></form-input>
                        <form-input v-model="contact.size_package" :error="errors.size_package" name="size_package" :label="$t('default.Packsize')" v-if="block.expanded"></form-input>
                        <form-input v-model="contact.lot_number" :error="errors.lot_number" name="lot_number" :label="$t('default.Lotnr')" :required="true"></form-input>
                        <form-radio v-model="contact.has_package" :error="errors.has_package" name="has_package" :label="$t('default.HasThePackaging')" :options="optionsYesNo" :required="true" v-if="block.expanded"></form-radio>
                        <form-radio v-model="contact.has_product" :error="errors.has_product" name="has_product" :label="$t('default.HasTheProduct')" :options="optionsYesNo" :required="true" v-if="block.expanded"></form-radio>

                        <section class="vraag w100 clearfix" v-if="block.expanded">
                                <p class="toelichting">{{ $t('default.SaveProductPackage') }}</p>
                        </section>

                        <div class="clear"></div>
                    </section>

                    <div class="clear"></div>

                    <template v-if="block.expanded">
                        <div class="title">
                            <h3>{{ $t('default.Whatisyourcomplaint') }}</h3>
                        </div>

                        <section class="col-sm-12 q">
                            <form-checkbox v-model="contact.complaints" :error="errors.complaints" name="complaints" :options="(site.country == 'BE')? optionsComplaintsBe : optionsComplaintsNl"></form-checkbox>
                            <form-textarea v-model="contact.description_complaint" :error="errors.description_complaint" name="description_complaint" :label="$t('default.DescriptionOfYourComplaint')" :required="true"></form-textarea>

                            <div class="clear"></div>
                        </section>

                        <div class="clear"></div>
                    </template>

                    <div class="title">
                        <h3>{{ $t('default.ContactData') }}</h3>
                    </div>

                    <section class="col-sm-12 q">
                            <section class="vraag w100 clearfix">
                                <p class="toelichting">{{ $t('default.AskForContactInformation') }}</p>
                            </section>

                            <form-radio v-model="contact.gender" :error="errors.gender" name="gender" :label="$t('default.HeaderStart')" :options="optionsGender" :required="true"></form-radio>
                            <form-input v-model="contact.first_letters" :error="errors.first_letters" name="first_letters" :label="$t('default.Firstletters')" v-if="block.expanded"></form-input>
                            <form-input v-model="contact.first_name" :error="errors.first_name" name="first_name" :label="$t('default.Firstname')" :required="true"></form-input>
                            <form-input v-model="contact.middle_name" :error="errors.middle_name" name="middle_name" :label="$t('default.Middlename')" v-if="block.expanded"></form-input>
                            <form-input v-model="contact.last_name" :error="errors.last_name" name="last_name" :label="$t('default.Lastname')" :required="true"></form-input>
                            <form-datepicker v-model="contact.year_of_birth" :error="errors.year_of_birth"  name="year_of_birth" :label="$t('default.Yearofbirth')" :options="options" v-if="block.show_year_of_birth" :required="true"></form-datepicker>
                            <form-input v-model="contact.email" :error="errors.email" name="email" :label="$t('default.Email')" :required="true"></form-input>
                            <form-input v-model="contact.phone" :error="errors.phone" name="phone" :label="$t('default.Phone')" :required="true"></form-input>
                            <form-input v-model="contact.street" :error="errors.street" name="street" :label="$t('default.Address')" :required="true"></form-input>
                            <form-input v-model="contact.zip_code" :error="errors.zip_code" name="zip_code" :label="$t('default.Zipcode')" :required="true"></form-input>
                            <form-input v-model="contact.city" :error="errors.city" name="city" :label="$t('default.City')" :required="true"></form-input>
                            <form-textarea v-model="contact.description_complaint" :error="errors.description_complaint" name="description_complaint" :label="$t('default.Whatisyourcomplaint')" :required="true" v-if="! block.expanded"></form-textarea>
                            <form-recaptcha ref="recaptcha" :error="errors.recaptcha"></form-recaptcha>
                    </section>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 next_prev">
                    <section class="col-md-2 col-sm-3 col-xs-4 buttons right">
                        <div class="row">
                            <button type="submit" class="button full" @click="submit" :disabled="disabled">{{ $t('default.Sendbutton') }}</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from "@/components/form-elements/FormInput.vue"
    import FormRadio from "@/components/form-elements/FormRadio.vue"
    import FormCheckbox from "@/components/form-elements/FormCheckbox.vue"
    import FormTextarea from "@/components/form-elements/FormTextarea.vue"
    import FormRecaptcha from "@/components/form-elements/FormRecaptcha.vue"
    import FormDatepicker from "@/components/form-elements/FormDatepicker.vue";
    import Block from "@/mixins/Block.js"
    import Gender from "@/mixins/Gender.js"
    import SetErrors from "@/mixins/SetErrors.js"
    import Options from "@/mixins/OptionsDatepicker.js"
    import i18n from "../i18n"
    import router from "@/router"
    import { axios } from "@/helpers"

    export default {
        components: {
            FormInput,
            FormRadio,
            FormCheckbox,
            FormTextarea,
            FormRecaptcha,
            FormDatepicker,
        },
        mixins: [Block, Gender, SetErrors, Options],
        data() {
            return {
                disabled: false,
                contact: {
                    name_product: null,
                    size_package: null,
                    lot_number: null,
                    has_package: null,
                    has_product: null,
                    complaints: null,
                    description_complaint: null,
                    gender: null,
                    first_letters: null,
                    first_name: null,
                    middle_name: null,
                    last_name: null,
                    year_of_birth: null,
                    email: null,
                    phone: null,
                    street: null,
                    zip_code: null,
                    city: null,
                },
                errors: {
                    name_product: null,
                    size_package: null,
                    lot_number: null,
                    has_package: null,
                    has_product: null,
                    complaints: null,
                    description_complaint: null,
                    gender: null,
                    first_letters: null,
                    first_name: null,
                    middle_name: null,
                    last_name: null,
                    year_of_birth: null,
                    email: null,
                    phone: null,
                    street: null,
                    zip_code: null,
                    city: null,
                    recaptcha: null,
                }
            }
        },
        computed: {
            optionsYesNo() {
                return [
                    {
                        'value': 1,
                        'label': this.$t('default.Yes')
                    },
                    {
                        'value': 0,
                        'label': this.$t('default.No')
                    },
                ];
            },
            optionsComplaintsBe() {
                return [
                    {
                        'value': 'AbnormalProduct',
                        'label': this.$t('default.AbnormalProduct'),
                        'title': this.$t('default.ExamplesAbnormalProduct') + '\n'
                        + this.$t('default.WrongTabletInblister') + '\n'
                        + this.$t('default.BrokenTabletInblister') + '\n'
                        + this.$t('default.WrongProductInBox') + '\n'
                        + this.$t('default.BatchNumberMissing') + '\n'
                        + this.$t('default.ExpirationDateMissing') + '\n'
                        + this.$t('default.DayIndicationUnclear') + '\n'
                        + this.$t('default.WrongRVG-number')
                    },
                    {
                        'value': 'IncompleteProduct',
                        'label': this.$t('default.IncompleteProduct'),
                        'title': this.$t('default.ExamplesIncompleteProduct') + '\n'
                        + this.$t('default.TooLittleTablets') + '\n'
                        + this.$t('default.TooLittleblisters') + '\n'
                        + this.$t('default.PackagingBrokenOpen') + '\n'
                        + this.$t('default.LeafletMissingInPackage')
                    },
                    {
                        'value': 'ProblemUseInstallProduct',
                        'label': this.$t('default.ProblemUseInstallProduct'),
                        'title': this.$t('default.ExamplesProblemUsageProduct') + '\n'
                        + this.$t('default.UnclearInstructionsDirections') + '\n'
                        + this.$t('default.RubberStopperDisappears') + '\n'
                        + this.$t('default.CapBottleCanNotBeOpened') + '\n'
                        + this.$t('default.PrecipitationSoilOrEdgeOfBottle') + '\n'
                        + this.$t('default.PreparedInjectionLeaks') + '\n'
                        + this.$t('default.ProblemPlacingIUD') + '\n'
                        + this.$t('default.ProblemInjectionOfProduct')
                    },
                    {
                        'value': 'Remainder',
                        'label': this.$t('default.Remainder'),
                        'title': ''
                    },
                ];
            },
            optionsComplaintsNl() {
                return [
                    {
                        'value': 'AbnormalProduct',
                        'label': this.$t('default.AbnormalProduct'),
                        'title': this.$t('default.ExamplesAbnormalProduct') + '\n'
                        + this.$t('default.WrongStripInBox') + '\n'
                        + this.$t('default.BrokenTabletInStrip') + '\n'
                        + this.$t('default.WrongProductInBox') + '\n'
                        + this.$t('default.BatchNumberMissing') + '\n'
                        + this.$t('default.ExpirationDateMissing') + '\n'
                        + this.$t('default.DayIndicationUnclear') + '\n'
                        + this.$t('default.WrongRVG-number')
                    },
                    {
                        'value': 'IncompleteProduct',
                        'label': this.$t('default.IncompleteProduct'),
                        'title': this.$t('default.ExamplesIncompleteProduct') + '\n'
                        + this.$t('default.TooLittleTablets') + '\n'
                        + this.$t('default.TooLittleStrips') + '\n'
                        + this.$t('default.PackagingBrokenOpen') + '\n'
                        + this.$t('default.LeafletMissingInPackage')
                    },
                    {
                        'value': 'ProblemUseInstallProduct',
                        'label': this.$t('default.ProblemUseInstallProduct'),
                        'title': this.$t('default.ExamplesProblemUsageProduct') + '\n'
                        + this.$t('default.UnclearInstructionsDirections') + '\n'
                        + this.$t('default.RubberStopperDisappears') + '\n'
                        + this.$t('default.CapBottleCanNotBeOpened') + '\n'
                        + this.$t('default.PrecipitationSoilOrEdgeOfBottle') + '\n'
                        + this.$t('default.PreparedInjectionLeaks') + '\n'
                        + this.$t('default.ProblemPlacingIUD') + '\n'
                        + this.$t('default.ProblemInjectionOfProduct')
                    },
                    {
                        'value': 'Remainder',
                        'label': this.$t('default.Remainder'),
                        'title': ''
                    },
                ];
            }
        },
        methods: {
            fixErrorsComplaints() {
                //general error on complaints array
                if(this.errors.complaints) {

                    return;
                }

                //filter out the errors for wrong values in the array
                for(const key in this.errors) {
                    if(key.indexOf("complaints.") !== -1) {
                        this.errors.complaints = this.errors[key];

                        break;
                    }
                }

                //clean up
                for(const key in this.errors) {
                    if(key.indexOf("complaints.") !== -1) {
                        delete this.errors[key];
                    }
                }
            },
            submit() {
                this.disabled = true;

                this.resetErrors();

                let params = JSON.parse(JSON.stringify(this.contact));//deep clone
                params.block_id = this.block.id;
                params.recaptcha = document.getElementsByClassName('g-recaptcha-response')[0].value;

                axios
                    .post('/' + i18n.locale.split("_")[0] + '/contact', params)
                        .then(response => {
                            this.disabled = false;

                            if(typeof response?.data?.success !== "undefined") {
                                this.$router.push({ name: 'app-complaint-thanks', params: { 'slug': router.currentRoute.params.slug, 'id': this.block.id, 'contact': this.contact } });
                            }

                        }).catch(error => {
                            this.disabled = false;

                            if(typeof error?.response?.data?.errors !== "undefined") {
                                this.setErrors(error.response.data.errors);
                                this.fixErrorsComplaints();
                            }

                        });
            }
        }
    }
</script>